import { BASE_URL } from '../components/AppConfig';

const getAuthToken = () => {
  const sessionToken = sessionStorage.getItem('sessionToken');
  return sessionToken ? `Bearer ${sessionToken}` : '';
};

const authFetch = async (path, options = {}) => {
  const token = getAuthToken();
  if (!token) {
    return { statusCode: '50000', message: 'Not authenticated' };
  }

  try {
    const response = await fetch(`${BASE_URL}${path}`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        ...(options.headers || {}),
      },
      ...options,
    });
    return response.json().catch(() => ({}));
  } catch {
    return { statusCode: '50000', message: 'Request failed' };
  }
};

export const isCompetitionRailApiSuccess = (res) =>
  String(res?.statusCode || '') === '10000' || res?.statusCode == null;

export const getCompetitionRailPayload = (res) => res?.data ?? null;

/** GET /admin/competition-rail */
export const listCompetitionRail = ({ scope = 'home_rail', search, limit = 50, offset = 0 } = {}) => {
  const params = new URLSearchParams({ scope });
  if (search) params.set('search', search);
  if (scope === 'all') {
    params.set('limit', String(limit));
    params.set('offset', String(offset));
  }
  return authFetch(`/admin/competition-rail?${params.toString()}`, { method: 'GET' });
};

/** GET /admin/competition-rail/ranking-logic */
export const getRankingLogic = () =>
  authFetch('/admin/competition-rail/ranking-logic', { method: 'GET' });

/** GET /admin/competition-rail/guest-order-preview */
export const getGuestOrderPreview = () =>
  authFetch('/admin/competition-rail/guest-order-preview', { method: 'GET' });

/** GET /admin/competition-rail/:cid */
export const getCompetitionRailItem = (cid) =>
  authFetch(`/admin/competition-rail/${cid}`, { method: 'GET' });

/** PATCH /admin/competition-rail/:cid */
export const updateCompetitionRail = (cid, body) =>
  authFetch(`/admin/competition-rail/${cid}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });

/** POST /admin/competition-rail/:cid/sync-entity */
export const syncCompetitionEntity = (cid) =>
  authFetch(`/admin/competition-rail/${cid}/sync-entity`, { method: 'POST' });

/** POST /admin/competition-rail/sync-entity/upcoming-live */
export const syncUpcomingLiveCompetitions = () =>
  authFetch('/admin/competition-rail/sync-entity/upcoming-live', { method: 'POST' });
